import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Hero.module.css';

const Hero = () => {
  // 使用 i18n 的翻译钩子
  const { t } = useTranslation();

  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.container}>
        <h1>{t('hero.announcement')}</h1>
        <p>{t('hero.description')}</p>
        {/* <a href="/products" className={styles.btn}>
          {t('hero.browseNow')} <i className="fas fa-arrow-right"></i>
        </a> */}
      </div>
    </section>
  );
};

export default Hero;